import { compileInitialInterestByRegionData } from 'components/Dashboard/Analytics/ui/InterestByRegion';
import { compileData } from './useCompileMentionsDataFunctions';

const compileChartResultsData = ({
  chartType,
  results,
  chartDataOption,
  analyticsState,
  currentData,
  interestByRegionCategories = ['Parliamentary contribution', 'Written questions', 'EDM'],
}) => {
  switch (chartType) {
    case 'Mentions':
      if (chartDataOption === 'Contribution type') {
        let value = compileData(results.data, analyticsState).value;
        return { ...results.data, value };
      }
      return results?.data;
    case 'Tweets':
      return results?.data;
    case 'Top MPs and peers':
      if (results.currentlyProcessing) {
        return {
          data: [],
          currentlyProcessing: { attempt: currentData?.currentlyProcessing?.attempt ?? 0 + 1, state: true },
        };
      }
      return { data: results, currentlyProcessing: { attempt: 0, state: false } };
    case 'Sentiment snapshot':
      return results;
    case 'Interest by region':
      return compileInitialInterestByRegionData(interestByRegionCategories, results);
    default:
      return results;
  }
};

export default compileChartResultsData;
